// Auto-generated by set-version.js
export const buildInfo = {
  version: '1.0.0',
  hash: 'TEMP-LWRKPN',
  builtAt: '2026-11-05T12:08:07.235Z'
};
